<template>
  <main
    key="default-layout"
    class="bg-gray-light min-h-dvh max-h-dvh flex flex-col overflow-hidden"
  >
    <LayoutSiteNav
      show-logout
      @logout="logout"
    />
    <slot name="content-wrapper">
      <v-container>
        <v-sheet
          :elevation="1"
          rounded="lg"
          class="sheet"
        >
          <slot name="default" />
        </v-sheet>
      </v-container>
    </slot>
  </main>
</template>

<script lang="ts" setup>
const { logout } = useAuth();
</script>

<style scoped lang="scss">
@reference "#tailwind.css";
main {
  .v-application.v-layout {
    @apply grow flex flex-col content-center items-center gap-6 ml-16;
  }
}
</style>

<style>
.v-application__wrap {
  max-height: 100dvh;
  overflow: hidden;
  overflow-y: auto;
}
</style>
